import { Pet } from '../../@types/ResumePetisSimulationProposal'
import { Coverages, useCoveragesStore } from '../../Stores/useCoveragesStore'

export const useCoverageHydration = () => {
  const { setCoverages } = useCoveragesStore()

  const handleCoverageHydration = (animalsProposal: Pet[]) => {
    const fullCoverages = animalsProposal.reduce(
      (acc, item) => ({
        ...acc,
        [`animal${item.id}`]:
          item.pack?.coverages?.map((coverage) => ({
            asfBranchCode: '',
            coverageDescription: coverage?.coverageDescription || '',
            coverageId: coverage?.coverageId || '',
            coverageName: coverage?.coverageName || '', //TODO: Review if name property will be added
            order: 0,
          })) || [],
      }),
      {},
    )

    setCoverages(fullCoverages as Coverages)
  }

  return { handleCoverageHydration }
}
